import React, { Component } from 'react';
import { includes } from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';
import { Money } from '../../lib/money';
import EditPurchaseComponent from '../../components/edit-purchase';

import {
  updatePurchase,
  projectPurchase,
  hideMakeChangesModal,
  showCancelPurchaseModal,
  EDIT_PURCHASE_NAMESPACE,
} from '../../actions';

import {
  getCurrentPurchase,
  getProjectedMemberships,
  getCommittedMemberships,
} from '../../selectors/purchase-selector';

class EditPurchase extends Component {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
    this.onCancelPurchase = this.onCancelPurchase.bind(this);
  }

  onSubmit(props) {
    const { splitType, minSlots, maxSlots, minContribution } = props;
    const { purchase, purchase: { group }, authentication } = this.props;

    const data = {
      group: {
        splitType: splitType || group.splitType,
        minSlots: minSlots || group.minSlots,
        maxSlots: props.setMaxSlots ? maxSlots || group.maxSlots : null,
        minContribution: minContribution || group.minContribution ||
         Money.zero(purchase.currencyCode),
      },
    };

    return this.props.actions.updatePurchase(purchase.id, authentication, data)
      .then(() => {
        window.location = `/purchases/${purchase.slug}`;
      })
      .catch(() => {
        throw new SubmissionError({
          _error: 'Error',
        });
      });
  }

  onCancelPurchase() {
    this.props.actions.hideMakeChangesModal();
    this.props.actions.showCancelPurchaseModal();
  }

  render() {
    const { purchase, shortMemberships } = this.props;

    return (
      <EditPurchaseComponent
        purchase={purchase}

        onSubmit={this.onSubmit}
        onCancelPurchase={this.onCancelPurchase}

        shortMemberships={shortMemberships}

        onChange={this.onFormChange}

        initialValues={this.props.initialValues}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const { session } = state;
  const currentPurchase = getCurrentPurchase(state);
  const committedMemberships = getCommittedMemberships(state).map(m => m.id);
  const projectedMemberships = getProjectedMemberships(state, EDIT_PURCHASE_NAMESPACE);
  const projectedShort = projectedMemberships.filter(m => m.short)
    .filter(m => includes(committedMemberships, m.id));

  return {
    authentication: session.authentication,
    shortMemberships: projectedShort,
    purchase: currentPurchase,
    initialValues: {
      splitType: currentPurchase.group.splitType,
      minSlots: currentPurchase.group.minSlots,
      maxSlots: currentPurchase.group.maxSlots || currentPurchase.group.minSlots + 1,
      setMaxSlots: currentPurchase.group.maxSlots,
      minContribution: currentPurchase.group.minContribution,
    },
  };
};

const mapDispatchToProps = (dispatch) => {
  const containerActions = {
    projectPurchase,
    updatePurchase,
    hideMakeChangesModal,
    showCancelPurchaseModal,
  };

  return {
    actions: bindActionCreators(containerActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditPurchase);



// WEBPACK FOOTER //
// ./src/desktop/containers/edit-purchase/index.container.js